/**
 * @author Harshitha.k
 * @description 
 */

import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';
import { DEPARTMENT } from '../../../../commons/api';
import localStorage from '../../../../utils/localStorage';
import StyledTable from '../../../../commons/styles/table';
import { DrawerFooter } from '../../../../commons/styles/layout';
import { Form, Input, Drawer, Button, message, Popconfirm, Select } from 'antd';
import { DeleteOutlined, EditOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';

const { Option } = Select;

const Department = (props) => {
  const [visible, setVisible] = useState(false);
  const [datasource, setDatasource] = useState([]);
  const [editObj, setEditObj] = useState({});
  const [searchText, setSearchText] = useState('');
  const departmentRef = useRef(null);
  const searchInputRef = useRef(null);

  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
    _getDepartmentList();
  }, [props.translationCache]);
  useEffect(() => {
    _getDepartmentList();
  }, []);

  const _getDepartmentList = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let headers = {
      method: 'GET',
      url: `${DEPARTMENT.GET}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(headers)
      .then(({ data }) => {
        setDatasource(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const openModal = () => {
    if (departmentRef.current) {
      departmentRef.current.resetFields();
    }
    setVisible(true);
    setEditObj({});
  };

  const _cancel = () => {
    if (departmentRef.current) {
      departmentRef.current.resetFields();
    }
    setVisible(false);
    setEditObj({});
  };

  const editDepartment = (obj) => {
    if (departmentRef.current) {
      departmentRef.current.setFieldsValue(obj);
    }
    setEditObj(obj);
    setVisible(true);
  };

  const _createDepartment = (e) => {
    e.preventDefault();
    departmentRef.current
      .validateFields()
      .then(async (values) => {
        delete values._key;
        _createDepartmentAPI(values);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const _updateDepartment = (e) => {
    e.preventDefault();
    departmentRef.current
      .validateFields()
      .then(async (values) => {
        values['Id'] = editObj['Id'];
        _updateDepartmentAPI(values);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const _deleteDepartment = (Id) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let orgDeleteHeaders = {
      method: 'DELETE',
      url: `${DEPARTMENT.DELETE}?SiteId=${siteId}&Id=${Id}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(orgDeleteHeaders)
      .then((response) => {
        if (response.status === 200 || response.status === 204) {
          message.success('Department Deleted');
          _getDepartmentList();
          setVisible(false);
          if (departmentRef.current) {
            departmentRef.current.resetFields();
          }
        }
      })
      .catch((error) => {
        message.error(error.response.data.message);
      });
  };

  const _createDepartmentAPI = (createObject) => {
    const SiteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let orgCreateHeaders = {
      method: 'POST',
      url: `${DEPARTMENT.CREATE}?SiteId=${SiteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: { ...createObject, SiteId }
    };
    axios(orgCreateHeaders)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          message.success(response.data.message);
          _getDepartmentList();
          setVisible(false);
          if (departmentRef.current) {
            departmentRef.current.resetFields();
          }
        }
      })
      .catch((error) => {
        if (error.response.status === 500) {
          message.error(error.response.data.message);
        }
      });
  };

  const _updateDepartmentAPI = (updateObject) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let orgUpdateHeaders = {
      method: 'PATCH',
      url: `${DEPARTMENT.UPDATE}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: updateObject
    };
    axios(orgUpdateHeaders)
      .then((response) => {
        if (response.status === 200) {
          message.success(response.data.message);
          _getDepartmentList();
          setVisible(false);
          setEditObj({});
          if (departmentRef.current) {
            departmentRef.current.resetFields();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const renderFormSwitch = (renderFormItems) => {
    switch (renderFormItems.Widget) {
      case 'Select':
        return (
          <Select
            style={{ width: 350 }}
            placeholder={`Select ${renderFormItems.Key}`}
            onChange={(e) =>
              departmentRef.current.setFieldsValue({ [renderFormItems.Key]: e })
            }
          >
            {renderFormItems.Options && renderFormItems.Options.map((option, index) => {
              if (
                renderFormItems.OptionsSettings &&
                renderFormItems.OptionsSettings.key &&
                renderFormItems.OptionsSettings.value
              ) {
                return (
                  <Option key={index} value={option[renderFormItems.OptionsSettings.value]}>
                    {option[renderFormItems.OptionsSettings.key]}
                  </Option>
                );
              }
              return (
                <Option key={index} value={option}>
                  {option}
                </Option>
              );
            })}
          </Select>
        );

      default:
        return (
          <Input
            style={{ width: 350 }}
            placeholder={translation(`Enter ${renderFormItems.Key}`)}
            disabled={renderFormItems.Key === 'Code' && editObj.Id}
          />
        );
    }
  };

  const onFinishFailed = () => {
    message.error('please enter required fields');
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInputRef}
          placeholder={translation(`Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}

          style={{ width: 90, marginRight: 8 }}
        >
          {translation('Search')}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}

          style={{ width: 90 }}
        >
          {translation('Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInputRef.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    ),
  });

  const columns = [
    {
      title: translation('Department Code'),
      dataIndex: 'Code',
      ...getColumnSearchProps('Code')
    },
    {
      title: translation('Department Name'),
      dataIndex: 'Name',
      ...getColumnSearchProps('Name')
    },
    {
      title: translation('Description'),
      dataIndex: 'Description',
      ...getColumnSearchProps('Description')
    },
    {
      title: translation('Action'),
      render: (text, record) => (
        <div>
          <Button
            type="primary"
            onClick={() => editDepartment(record)}
            style={{ marginRight: '10 px' }}
          >
            <EditOutlined />
          </Button>
          {record && record.Default && record.Default !== true ? (
            <Popconfirm
              title={translation('Are you sure delete Department?')}
              onConfirm={(e) => {
                e.stopPropagation();
                _deleteDepartment(record.Id);
              }}
              okText={translation('Yes')}
              cancelText={translation('No')}
            >
              <Button type="primary">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          ) : null}
        </div>
      )
    }
  ];

  const formStructure = [
    {
      DisplayName: 'Code',
      Key: 'Code',
      Widget: 'Input'
    },
    {
      DisplayName: 'Name',
      Key: 'Name',
      Widget: 'Input'
    },
    {
      DisplayName: 'Description',
      Key: 'Description',
      Widget: 'Input'
    }
  ];

  return (
    <>
      <Drawer
        title={!editObj.Id ? translation('Create Department') : translation('Update Department')}
        open={visible}
        width={600}
        closable
        onClose={_cancel}
      >
        <Form
          layout="vertical"
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 14 }}
          ref={departmentRef}
          name="user_form"
          initialValues={editObj || {}}
          onFinishFailed={onFinishFailed}
        >
          {formStructure && Array.isArray(formStructure) && formStructure.map((formItem, index) => (
            <Form.Item key={index} name={formItem.Key} label={translation(formItem.DisplayName)}>
              {renderFormSwitch(formItem)}
            </Form.Item>
          ))}
        </Form>
        <DrawerFooter>
          <Button onClick={_cancel} type='primary' style={{ marginRight: 8 }}>
            {translation('Cancel')}
          </Button>
          {!editObj.Id ? (
            <Button type="primary" onClick={_createDepartment}>
              {translation('Create')}
            </Button>
          ) : (
            <Button type="primary" onClick={_updateDepartment}>
              {translation('Update')}
            </Button>
          )}
        </DrawerFooter>
      </Drawer>
      <Button
        type="primary"
        style={{
          marginBottom: '10px',
        }}
        onClick={openModal}
      >
        <PlusOutlined />
        {translation('Add')}
      </Button>
      <StyledTable size="small"
        columns={columns}
        dataSource={datasource}
        pagination={
          datasource.length > 10
            ? {
              pageSize: '10'
            }
            : false
        }
        bordered
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache
  };
};

export default connect(mapStateToProps)(Department);
